import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="rounded-xl overflow-hidden transition-all duration-300 border border-white/10" style={{
    backgroundColor: isOpen ? 'rgba(15, 60, 60, 0.8)' : '#0F3C3C'
  }} data-id="element-127">
      <button className="w-full p-5 flex justify-between items-center text-left focus:outline-none" onClick={onClick} data-id="element-128">
        <span className="text-base font-bold text-white pr-4" data-id="element-129">{question}</span>
        <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} style={{
        color: isOpen ? '#D4AF37' : 'rgba(255,255,255,0.5)'
      }} data-id="element-130" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-131">
        <p className="p-5 pt-0 text-white/70 leading-relaxed text-sm" data-id="element-132">
          {answer}
        </p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Es un libro físico?',
    answer: 'No, es un producto 100% digital. Recibirás acceso inmediato a todo el contenido en formato digital, optimizado para leer desde tu móvil, tablet u ordenador. Podrás consultarlo en cualquier momento, incluso justo antes de salir a pasear.'
  }, {
    question: '¿Por qué tan barato?',
    answer: 'Porque nuestro objetivo es que el mayor número posible de dueños recupere la calma en sus paseos. El precio de lanzamiento de 9,95€ es temporal. El valor real del pack supera los 113€ y el precio subirá próximamente.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tienes 14 días de garantía total. Si no ves resultados o simplemente no es lo que esperabas, te devolvemos el 100% de tu dinero con un solo clic. Sin preguntas, sin complicaciones.'
  }, {
    question: '¿Funciona en perros adultos?',
    answer: 'Absolutamente. El protocolo DOG-CALM trabaja con la biología del estrés (cortisol), que funciona igual en cachorros que en perros adultos o senior. De hecho, muchos de nuestros mejores resultados son con perros de +3 años que llevaban tiempo con problemas de reactividad.'
  }];
  return <section className="py-12 px-5" data-id="element-133">
      <div className="max-w-lg mx-auto" data-id="element-134">
        <h2 className="text-xl md:text-2xl font-bold text-white text-center mb-8" data-id="element-135">
          Preguntas frecuentes
        </h2>
        <div className="flex flex-col gap-3" data-id="element-136">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-137" />)}
        </div>
      </div>
    </section>;
}